import { Box } from "@mui/material";
import {
  People as ClientsIcon,
  FitnessCenter as WorkoutIcon,
  Restaurant as NutritionIcon,
  DirectionsWalk as StepsIcon,
  MonitorWeight as WeightIcon,
  CheckCircleOutline as CheckinsIcon,
} from "@mui/icons-material";
import { t } from "./coachTokens";

export const DASHBOARD_TABS = [
  { key: "clients", label: "לקוחות", Icon: ClientsIcon },
  { key: "workouts", label: "אימונים", Icon: WorkoutIcon },
  { key: "nutrition", label: "תזונה", Icon: NutritionIcon },
  { key: "steps", label: "צעדים", Icon: StepsIcon },
  { key: "weight", label: "שקילות", Icon: WeightIcon },
  { key: "checkins", label: "צ׳ק-אינס", Icon: CheckinsIcon },
];

const TabsRow = ({ value, onChange, tabs = DASHBOARD_TABS }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "14px", flexWrap: "wrap" }}>
    {tabs.map(({ key, label, Icon, hasAlert }) => {
      const on = value === key;
      return (
        <Box
          key={key}
          component="button"
          onClick={() => onChange(key)}
          sx={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 16px",
            borderRadius: "20px",
            fontSize: "12.5px",
            fontWeight: on ? 600 : 500,
            color: on ? "#fff" : t.t2,
            cursor: "pointer",
            border: `1.5px solid ${on ? t.green : t.border}`,
            background: on ? `linear-gradient(135deg, ${t.green}, ${t.greenDark})` : t.white,
            fontFamily: "inherit",
            whiteSpace: "nowrap",
            boxShadow: on ? "0 4px 14px rgba(1,187,167,.35)" : "0 1px 3px rgba(15,20,40,.04)",
            transition: "all .15s",
            "&:hover": { borderColor: on ? t.green : t.t3, color: on ? "#fff" : t.text },
          }}
        >
          <Icon sx={{ fontSize: 16 }} />
          {label}
          {hasAlert && (
            <Box
              data-testid="tab-alert-dot"
              sx={{
                position: "absolute",
                top: -3,
                right: -3,
                width: 9,
                height: 9,
                borderRadius: "50%",
                backgroundColor: t.red,
                border: `2px solid ${t.bg}`,
                boxSizing: "content-box",
                pointerEvents: "none",
              }}
            />
          )}
        </Box>
      );
    })}
  </Box>
);

export default TabsRow;
